export default __webpack_public_path__ + "static/media/logo.4254e0a2.svg";